import { PageContainer, PageTabs } from '@if/mui'
import FailedVendorsSection from '@src/components/Admin/TransactionRetry/FailedVendorsSection'
import FailedTransactionsSection from '@src/components/Admin/TransactionRetry/FailedTransactionsSection'
import { useTranslation } from 'react-i18next'

const TRANSACTIONS_TAB = 'transactions'
const MERCHANTS_TAB = 'merchants'

const TransactionRetryPage = () => {
  const { t } = useTranslation()

  return (
    <PageContainer title={t('admin.transactionRetry.pageTitle')}>
      <PageTabs
        label={t('admin.transactionRetry.tabs.label')}
        tabs={[
          {
            value: TRANSACTIONS_TAB,
            label: t('admin.transactionRetry.tabs.transactions'),
            content: <FailedTransactionsSection />,
          },
          {
            value: MERCHANTS_TAB,
            label: t('admin.transactionRetry.tabs.merchants'),
            content: <FailedVendorsSection />,
          },
        ]}
      />
    </PageContainer>
  )
}

export default TransactionRetryPage
